import React, { useState, useEffect } from 'react';

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);
  const [atTop, setAtTop] = useState(true); // Track whether at top or not

  useEffect(() => {
    const toggleVisibility = () => {
      const yOffset = window.pageYOffset;
      setVisible(yOffset > 300 || yOffset < document.body.scrollHeight - window.innerHeight - 300);
      setAtTop(yOffset <= 300);
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const handleClick = () => {
    if (atTop) {
      // Scroll to bottom
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth',
      });
    } else {
      // Scroll to top
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  return (
    <>
      {visible && (
       <button onClick={handleClick} style={styles.button}>
       <span style={{ color: "gold", fontWeight: "bold", fontSize: "24px" }}>
         {atTop ? <img width="35" height="35" src="https://img.icons8.com/color/48/chevron-down.png" alt="chevron-up"/> : <img width="35" height="35" src="https://img.icons8.com/color/48/chevron-up.png" alt="chevron-down"/>}
       </span>
     </button>
     
      )}
    </>
  );
};

const styles = {
  button: {
    position: 'fixed',
    bottom: '30px',
    right: '30px',
   
    backgroundColor: "#2a0947",
    border: "none",
  
    padding: "10px",
    fontSize: '24px',
    fontWeight: 'bold',
    cursor: 'pointer',
    borderRadius: "50%",          // optional: makes it circular
  outline: "none",
    zIndex: 1000,
    transition: 'opacity 0.3s ease',
  }
};



export default ScrollToTopButton;
